import React from "react"

function Inspiration() {
  return (
    <div className="inspiration">
      <h1>Inspiration</h1>

      <p className="inspiration-text">
        As one of my many projects, I reached out to friends, my mom, and women
        I've met over the years. I asked them to send me quotes from Black women
        who inspire them daily. I collected over 65 quotes and stored them in a
        downloadable npm package to make them accessible to everyone. The
        package has a simple API and generates a random quote from the list with
        the author's name. I designed this package to help infuse your newest
        project, webpage, desktop app, or another creative endeavor with
        timeless quotes by Black women for the world to see. The packed is
        called "black-women-inspire" and is availble for download on the npm
        package registry.
      </p>
    </div>
  )
}

export default Inspiration
